export default __webpack_public_path__ + "static/media/learning.5419a0f0.svg";